/**
 * Authors: mariushirjanu
 * Created: 07/05/2021
 */

import { Component, ElementRef, Input, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'iframe-container',
  template: `
    <div *ngIf="src" [ngStyle]="{'height.px': height}">
      <h3 *ngIf="loading" class="activity-indicator">
        <activity-indicator>
          <span translate>GA.LOADING_SIMPLE</span>…
        </activity-indicator>
      </h3>
      <iframe #iframe [name]="name" [src]="url" scrolling="{{ scrolling ? 'auto' : 'no' }}" (load)='onLoad()'></iframe>
    </div>
	`,
  styleUrls: [ './iframe-container.scss' ]
})
export class IframeContainerComponent implements OnChanges {
  @Input() public name:string;
  @Input() public src:string;
  @Input() public height:string;
  @Input() public scrolling:boolean;

  @ViewChild('iframe', { static: false }) public iframe:ElementRef;

  public loading:boolean = true;
  public url:SafeResourceUrl;

  constructor(
    private domSanitizer:DomSanitizer
  ) {/***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.src?.currentValue) {
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(changes.src.currentValue);
    }
  }

  public onLoad():void {
    this.loading = false;
  }
}